var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#updated)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E0E5EE"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#475569",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.714 8A3.714 3.714 0 0 1 4.57 9.429M4.285 8a3.714 3.714 0 0 1 7.144-1.428"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#475569",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.714 5.429v1.143h-1.429m-6 4V9.429h1.143"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "updated"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdated);
export default __webpack_public_path__ + "static/media/updated.8e1b0b639a703cb1ca7b87b78cca4f86.svg";
export { ForwardRef as ReactComponent };